
/* eslint-disable */
import { dragMoveAction1 } from "@/common/utils/drag.js";
import numberComma from 'vux/src/tools/number/comma.js'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Countup from 'vux/src/components/countup/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Icon from 'vux/src/components/icon/index.vue'


import GameList from "../components/game/list.vue";
import HomeXDialog from "./components/home-x-dialog.vue";
import notice from "./components/notice.vue";
import loginInfo from "./components/loginInfo.vue";
import { common, commonApi, filter } from "@/common/index";
import { mapState, mapMutations, mapGetters } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";

import { parseTime } from "@/common/utils/Date.js";
import LoginInfo from "./components/loginInfo.vue";

export default {
name: "home",
components: {
Swiper,
SwiperItem,
Flexbox,
FlexboxItem,
ViewBox,
awesomeSwiper: swiper,
swiperSlide,

GameList,
Countup,
XDialog,
Icon,
HomeXDialog,
notice,
LoginInfo,
},
filters: {
numberFilter(num) {
return numberComma(num);
},
jackpotUserName(time) {
return filter.jackpotUserName(time);
},
timeFilter(time) {
return parseTime(time);
},
},
data() {
let vm = this;
return {
isShowHeaderNav: false,
homePendant: null, //首页挂件
homeSwiperOptions: {
slidesPerView: 1,
loop: true,

autoplay: {
delay: 5000,
disableOnInteraction: false,
},
pagination: {
el: ".swiper-pagination",
clickable: true,
},
on: {
tap: () => {



vm.handleSwiperSlide(this.$refs.homeSwiper.swiper.realIndex);
},
},
},
bannerList: [],
customMatchList: null, // 自定义赛事
iskeep: true,
};
},
computed: {
...mapState({
frontType: (state) => state.frontType,
picLink: (state) => state.picLink,
isLogin: (state) => state.isLogin,
isHorizontal: (state) => state.isHorizontal, // 是否横屏
customer_service_system_link: (state) =>
state.FrontConfigList.customer_service_system_link,
pro3StarMoney: (state) => state.pro3StarMoney,
}),
bannerInfo() {

return this.bannerList;

},
},
watch: {
isHorizontal(v) {


},
},
created() {

this._getBanner(); 

},
mounted() {

dragMoveAction1("H5Drag");
},
methods: {
_getH5() {

commonApi.HOMEBEFORE.getHomePendant("h5HomePendant").then((data) => {
this.homePendant = data;
});
},

_getBanner() {

commonApi.HOMEBEFORE.getHomePendant("homeBanner").then((data) => {
this.bannerList = data || [];
});
},











handlMatch(jumpUrl) {

if (!jumpUrl) return;
const platformKey = jumpUrl.slice(0, jumpUrl.indexOf("&"));
const platformCode = jumpUrl.slice(jumpUrl.indexOf("&") + 1);
const item = { platformKey, platformCode, gameType: "3" };
if (common.getUpload(item) === "1") {

this.$store.commit("setupholdShow", true);
} else {
if (this.isLogin) {
common.goGame(
item,
this.isLogin,
this.$store.state.UUID,
this.$router
);
} else {
this.$store.commit("SET_LOGIN_SHOW");
}
}
},

handleSwiperSlide(index) {

const { imgClickLink, imgName } = this.bannerInfo[index];
if (imgName === "CustomizeMatch") return;
if (imgClickLink === "") return;
if (imgClickLink.indexOf("http") === -1) {
this.$router.push({ path: imgClickLink.replace("#", "") });
} else {

window.location.href = imgClickLink;
}
},

handleH5({ imgClickLink }) {

if (imgClickLink === "") return;
if (imgClickLink.indexOf("http") === -1) {
if (this.isLogin) {
this.$router.push({ path: imgClickLink.replace("#", "") });
} else {
this.SET_LOGIN_SHOW();
}
} else {

window.location.href = imgClickLink;
}
},


goDetail(obj) {


let thirdType = obj.thirdType;

if (thirdType === "1") {
let params = {
viewOfferId: obj.id,
thirdType: thirdType,
};
this.$router.push({
path: "/discounts/liveFirstDiscounts",
query: params,
});
} else if (thirdType !== "1") {
let params = {
viewOfferId: obj.id,
thirdType: thirdType,
};
this.$router.push({
path: "/discounts/discountsDetail",
query: params,
});
}
},
...mapMutations([
"SET_NAV_LIST",
"SET_COLOR_DOWNLOADSHOW",
"SET_LOGIN_SHOW",
"set_bottom",
]),
goTo(obj) {
this.$router.push({
path: obj.url,
});
},

hidedownload() {
this.SET_COLOR_DOWNLOADSHOW();
},
},
destroyed() {

},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/Home/index.vue